import { useTranslation } from "react-i18next";
import { Outlet, NavLink } from "react-router-dom";

export function TermsContainer() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col flex-grow min-h-0">
      <header className="sticky top-0 flex items-center h-16 p-4 bg-white shadow">
        <div>
          <NavLink to="/auth/signin">
            <img
              src="/assets/images/track_logo.svg"
              alt="logo"
              className="h-8"
            />
          </NavLink>
        </div>
      </header>
      <main className="flex flex-col flex-grow py-16 px-4 gap-10 overflow-auto min-h-0">
        <h1 className="text-2xl font-bold text-center">{t("terms.title")}</h1>
        <div className="flex flex-col bg-white rounded-lg shadow p-8 max-w-3xl mx-auto w-full prose track-terms">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
